import { BCMSRecord, useBCMSContext } from "@bcm-dev/bcms-vite";
import Util from "classes/Util";
import AccountDetailsPage from "components/pages/AccountDetailsPage";
import Classes from "model";
import { useEffect } from "react";

export default function CaptureAccountsAccountDetails(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const { branding } = context.state;

    useEffect(() => {
        Util.replaceDOMDataPointValues(branding);
    });

    return <AccountDetailsPage />
}